/** Navigation arrow markup with icomoon icon. */
export const prevArrowMarkup = `
<button type="button" class="slider-svg-arrow slider-svg-arrow_prev swiper-button-prev" aria-label="Previous slide">
  <i class="icon icon-slider-arrow-next" aria-hidden="true"></i>
</button>`

export const nextArrowMarkup = `
<button type="button" class="slider-svg-arrow slider-svg-arrow_next swiper-button-next" aria-label="Next slide">
  <i class="icon icon-slider-arrow-next" aria-hidden="true"></i>
</button>`
